<template>
  <div
    v-show="show"
    @click="onMaskClick"
    class="ols-alert-mask"
    :class="{'ols-alert-mask-animate': animate}"
  >
    <div class="ols-alert-wrap" :class="{'ols-alert-wrap-animate': animate}">
      <slot name='header'>
        <div class="ols-alert-header">
          <p class="ols-alert-header-p" v-html="title"></p>
        </div>
      </slot>
      <slot name='body'>
        <div class="ols-alert-body">
          <p class="ols-alert-body-p" v-html="content"></p>
        </div>
      </slot>
      <slot name='footer'>
        <div class="ols-alert-footer" :style="btnDirection">
          <button @click="emitEvent('on-confirm')" :style="btnStyle" class="ols-alert-footer-b" v-html="buttonArr[0]"></button>
          <button @click="emitEvent('on-cancel')" :style="btn1Style" class="ols-alert-footer-b" v-if="buttonArr[1]" v-html="buttonArr[1]"></button>
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      animate: false,
      eventName: '',
      localShow: this.show
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '提示'
    },
    content: String,
    buttonText: {
      type: [Array, String],
      default: '确定'
    },
    btnColor: String,
    btn1Color: String,
    btnTextColor: String,
    btn1TextColor: String,
    closeByMask: {
      type: Boolean,
      default: true
    },
    buttonReverse: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  methods: {
    hideDialog () {
      this.animate = false
      setTimeout(() => {
        this.$emit('change', false)
      }, 300)
    },
    showDialog () {
      this.emitEvent('on-show')
      this.$emit('change', true)
      setTimeout(() => (this.animate = true), 50)
    },
    emitEvent (type) {
      this.eventName = type
      this.$emit(type)
      if (type !== 'on-show') {
        this.hideDialog()
        if (type !== 'on-hide') {
          this.$nextTick(() => this.emitEvent('on-hide'))
        }
      }
    },
    onMaskClick ({ target: { className: cn } }) {
      if (cn.includes('ols-alert-mask') && this.closeByMask) {
        this.emitEvent('on-hide')
      }
    }
  },
  computed: {
    buttonArr () {
      return typeof this.buttonText === 'string' ? [this.buttonText] : this.buttonText
    },
    btnStyle () {
      return {
        background: this.btnColor ? this.btnColor : null,
        color: this.btnTextColor ? this.btnTextColor : null
      }
    },
    btn1Style () {
      return {
        background: this.btn1Color ? this.btn1Color : null,
        color: this.btn1TextColor ? this.btn1TextColor : null
      }
    },
    btnDirection () {
      return {
        'flex-direction': this.buttonReverse ? 'row' : 'row-reverse'
      }
    }
  },
  watch: {
    show (newVal) {
      newVal ? this.showDialog() : this.hideDialog()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/alert/index.vue